module.exports = __webpack_public_path__ + "static/media/frames-colls-colored-filled.4db48176.png";